import { Image } from "../Image";
import { List, ListDisplayType } from "../List";
import { Tile } from "../Tile";

export class MockList implements List {
  private static INDEX = 0;

  public uuid: string;
  public display = ListDisplayType.HERO;
  public imgBackground?: Image[];
  public imgBanner?: Image[];
  public imgMore?: Image[];
  public isPaginated = false;
  public moreLink?: string;
  public moreTitle?: string;
  public tiles: Tile[] = [];
  public title?: string;
  public total = 0;

  constructor() {
    this.tiles = [];
    MockList.INDEX++;
    this.uuid = `${MockList.INDEX}`;
  }
}
